import nodeEnv from '../../Constants/nodeEnv.constant';
export default function routingConfig($stateProvider) {
    $stateProvider.state('App.Home', {
        url: '',
        component: 'homeComponent',
        redirectTo: nodeEnv.development ? false : 'App.Wip'
    });
}
routingConfig.$inject = ['$stateProvider'];
